<div fxLayout="column" fxLayoutGap="14px">
    <h3>General</h3>
    <div fxLayout="row wrap" fxLayoutGap="10px">
        <mat-form-field fxFlex>
            <mat-label i18n="@@id">Id</mat-label>
            <input matInput i18n-placeholder placeholder="e.g. 1" [ngModel]="data._id" readonly />
        </mat-form-field>

        <mat-form-field fxFlex>
            <mat-label i18n="@@version">Version</mat-label>
            <input matInput i18n-placeholder placeholder="e.g. 0" [ngModel]="data._version" readonly />
        </mat-form-field>
    </div>

    <h3>Created</h3>
    <div fxLayout="row wrap" fxLayoutGap="10px">
        <mat-form-field fxFlex>
            <mat-label i18n="@@createdAt">Created At</mat-label>
            <input matInput i18n-placeholder placeholder="e.g. 2025-03-23" [ngModel]="data._createdAt"
                readonly />
        </mat-form-field>

        <mat-form-field fxFlex>
            <mat-label i18n="@@createdBy">Created By</mat-label>
            <input matInput i18n-placeholder placeholder="e.g. 1" [ngModel]="data._createdBy"
                readonly />
        </mat-form-field>
    </div>

    <h3>Updated</h3>
    <div fxLayout="row wrap" fxLayoutGap="10px">
        <mat-form-field fxFlex>
            <mat-label i18n="@@updatedAt">Updated At</mat-label>
            <input matInput i18n-placeholder placeholder="e.g. 2025-03-23" [ngModel]="data._updatedAt"
                readonly />
        </mat-form-field>

        <mat-form-field fxFlex>
            <mat-label i18n="@@updatedBy">Updated By</mat-label>
            <input matInput i18n-placeholder placeholder="e.g. 1" [ngModel]="data._updatedBy"
                readonly />
        </mat-form-field>
    </div>
</div>